import * as React from "react";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

const TimeInput = React.forwardRef<HTMLInputElement, Omit<React.ComponentProps<typeof Input>, "type">>(
  ({ className, ...props }, ref) => {
    return (
      <Input
        type="time"
        ref={ref}
        className={cn(
          "appearance-none [&::-webkit-calendar-picker-indicator]:hidden [&::-webkit-calendar-picker-indicator]:appearance-none",
          className,
        )}
        {...props}
      />
    );
  },
);
TimeInput.displayName = "TimeInput";

export { TimeInput };
